import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useHttpStatus from '../../../commons/hooks/useHttpStatus';
import FormThemeReportsManagement from './FormThemeReportsManagement.jsx';
import PageHttp from '../../../commons/components/PageHttp.jsx';
import env from '../../../commons/config/env.js';

const PageThemeReportsManagement = () => {
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({
      url: 'api/themeReports//by-user',

    });
  }, []);

  return (
        <>

        <PageHttp res={res}>
              {(doc) => {
                console.log({ doc });
                if (!doc) {
                  return (
                          <>
                          <FormThemeReportsManagement/>
                          </>
                  );
                }
                return (
                      <>
                          <FormThemeReportsManagement themeReport={doc} />
                      </>
                );
              }}
        </PageHttp>
    </>
  );
};

export default PageThemeReportsManagement;
